/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_StageInputs */

const cs_col_stage = /** @type {(inputs: Col_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fáze`)
};

const en_col_stage = /** @type {(inputs: Col_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage`)
};

/**
* | output |
* | --- |
* | "Stage" |
*
* @param {Col_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_stage = /** @type {((inputs?: Col_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_stage(inputs)
	return cs_col_stage(inputs)
});